import React from 'react';
import { observer } from 'mobx-react';
import { Review } from '@/components/ratingAndReview/popup/content/ReviewStep.sc';
import { RatingPopupStore } from '@/components/ratingAndReview/popup/ratingPopup.store';

interface ReviewStepProps {
  store: RatingPopupStore;
}

const ReviewStepPure = ({ store }: ReviewStepProps) => {
  const handleChange = (e) => {
    const value: string = e.target.value;
    store.setContent(value.slice(0, 1000));
  };

  return (
    <Review
      fullWidth
      minRows={8}
      maxRows={8}
      textVariant="body1"
      label="Write a review (optional)"
      value={store.content}
      onChange={handleChange}
      data-test-automation-id="rating-popup-review"
    />
  );
};

export const ReviewStep = observer(ReviewStepPure);
